import { useAuth0 } from '@auth0/auth0-react';
import useSWR, { SWRResponse } from 'swr';
import useSWRMutation from 'swr/mutation';
import useCompanyId from '@/Hooks/UseCompanyId';
import http from '@/Utils/HTTP/NewHttpUtils';
import { DefaultRecruiterSignatureResponse, RecruiterSignatureResponse } from './DTO/RecruiterSignatureResponse';
import UpdateRecruiterSignatureRequest from './DTO/UpdateRecruiterSignatureRequest';

const getRecruiterSignatureEndpointPath = (companyId: string) => {
    return `settings/company/${companyId}/signature`;
};

export const useRecruiterSignature = (): SWRResponse<RecruiterSignatureResponse> => {
    const { getAccessTokenSilently } = useAuth0();
    const companyId = useCompanyId();
    const recruiterSignatureEndpointPath = getRecruiterSignatureEndpointPath(companyId);

    return useSWR(recruiterSignatureEndpointPath, async (path) => {
        const response = await http.get<RecruiterSignatureResponse>({
            path,
            accessToken: await getAccessTokenSilently(),
        });

        return response || DefaultRecruiterSignatureResponse;
    });
};

export const useUpdateRecruiterSignature = () => {
    const { getAccessTokenSilently } = useAuth0();
    const companyId = useCompanyId();
    const recruiterSignatureEndpointPath = getRecruiterSignatureEndpointPath(companyId);

    return useSWRMutation(
        recruiterSignatureEndpointPath,
        async (path: string, { arg }: { arg: UpdateRecruiterSignatureRequest }) => {
            await http.post({
                path,
                accessToken: await getAccessTokenSilently(),
                body: arg,
            });
        },
    );
};
